import PaymentFailedPage from 'Pages/PaymentFailedPage/PaymentFailedPage'
import PaymentSuccessPage from 'Pages/PaymentSuccessPage/PaymentSuccessPage'
import React from 'react'
import { useParams } from 'react-router-dom'

const PaymentStripeStatus = (props) => {
   const {status} = useParams()
  
    // successstatus",
    // cancelstatus;
    return (
        
    status==='successstatus' ? <PaymentSuccessPage/> : status === 'cancelstatus' ? <PaymentFailedPage/> : <>Not Found !</>
    )
}

export default PaymentStripeStatus